import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

interface SortIconProps<K extends string> {
  col: K;
  current: K;
  dir: 'asc' | 'desc';
}

export function SortIcon<K extends string>({ col, current, dir }: SortIconProps<K>) {
  if (col !== current) return <ArrowUpDown className="ml-1 h-3.5 w-3.5 inline opacity-40" />;
  return dir === 'asc'
    ? <ArrowUp className="ml-1 h-3.5 w-3.5 inline text-primary" />
    : <ArrowDown className="ml-1 h-3.5 w-3.5 inline text-primary" />;
}
